import Article from "../components/Article/Article";
import ArticlePage from "../components/Article/ArticlePage";
import api from "../lib/api";

export default function Index({ data }) {
  return (
    <ArticlePage>
      <Article data={data[0].article} />
    </ArticlePage>
  );
}

export async function getStaticProps({ locale }) {
  const data = await api.getDataAndLocalize(
    "/api/collections/research-navigation/entries",
    {
      filter: "[slug]=home",
      fields: ["article"],
      locale,
    },
  );

  return await api.injectDefaultData({ props: { data }, revalidate: 3 }, locale);
}
